const chromelessRoutes = [
  'checkout',
  'checkout-freemium',
  'onboarding',
  'plans',
  'plans-freemium',
  'quiz',
  'redeem',
  'restricted',
  'signin',
  'tab-viewer',
  'welcome-screen',
];

function isChromelessRoute(routeStr, routes = chromelessRoutes) {
  let isChromeless = false;
  if (routeStr) {
    const playSplit = routeStr.split('/play/');
    const afterPlay = playSplit.length > 1 ? playSplit[1] : playSplit[0];
    const slashSplit = afterPlay.split('/');
    const rootPath = slashSplit[0] === '' ? slashSplit[1] : slashSplit[0];
    routes.forEach(str => {
      if (rootPath === str) {
        isChromeless = true;
      }
    });
  }
  return isChromeless;
}

export { chromelessRoutes, isChromelessRoute };
